<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"><button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">&#8592;</button></div>
        <h3 class="col-sm" v-html="data.sampling.statusHeader"></h3>
        <div class="col-sm"></div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <h4 class="text-sampling" v-html="data.sampling.samplingHeader"></h4>
          <div class="clearfix--min"></div>
          <div v-html="data.sampling.samplingExplanation"></div>
          <div class="card card-sp" v-for="(url, label) in data.sampling.samplingSites" v-bind:key="label">
            <a :href="url" target="_blank">{{ label }}</a>
          </div>
          <div class="clearfix--min"></div>
          <small v-html="data.sampling.samplingDisclaimer"></small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'

export default {
  name: 'sampling',
  components: {},
  data () {
    return {
      data: null,
      language: sessionStorage.getItem('language'),
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  methods: {},
  watch: {},
  async mounted () {
    this.data = await request({
      query: `
        {
          sampling(locale: ` + sessionStorage.getItem('language') + `) {
            statusHeader
            samplingHeader
            samplingExplanation
            samplingBtn
            samplingDisclaimer
            samplingSites
          }
        }
      `
    })
    window.scrollTo(0, 0)
  },
  created () {
    sessionStorage.removeItem('verificationCode')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
button:disabled {
  opacity: 0.3;
}
.card {
  min-height: auto !important;
}
.img {
  border-radius: 10px;
  width: 20vw;
  margin-left: auto;
  margin-right: auto;
}
.alert-error {
  display: none;
}
.text-sampling {
  color: #0CA789 !important;
}
.card-sp {
  margin: 10px;
  background: #E5EDE5 !important;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sampling.vue